import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import WidgetFrame from '../../Utils/Widget/Frame/Frame.jsx';
import WidgetTitle, { ALIGN } from '../../Utils/Widget/Title/Title.jsx';

import { getLocationName, getDemographicInfo } from '../../../selectors/selectors.js';
import tileConfig from '../tileConfig.js';

import styles from './Widget.less';
import { Desktop, Mobile, Tablet } from '../../Utils/MediaComponents/MediaComponents';

export class DemographicInfoWidget extends React.Component {
  renderResponsiveStats = () => {
    const [durationOfResidence, residentsAge, families, singles] = tileConfig;
    const { demographicInfo } = this.props;
    return (
      <div className={`grid grid-flex ${styles.widgetDataGrid}`}>
        {[durationOfResidence, residentsAge, singles, families].map((item, index) => (
          <div key={index} className={`grid-item ${styles.widgetDataGridItem} demographic-stat-item`}>
            <Mobile render={() => <div className={`padding-bottom-s ${styles.title}`}>{item.title}</div>} />

            <div className={styles.value} id="age">
              {demographicInfo[item.key]} {item.postFix || ''}
            </div>

            <Tablet render={() => <div className={`${styles.title} padding-top-xs`}>{item.title}</div>} />

            <Desktop render={() => <div className={`${styles.title} padding-top-xs`}>{item.title}</div>} />
          </div>
        ))}
      </div>
    );
  };

  render() {
    return (
      <WidgetFrame>
        <div className={styles.widgetMainContainer}>
          <div id="demographic-info-widget" className="grid">
            <WidgetTitle
              id="demographic-info"
              align={ALIGN.center}
              text="Statistiken zur Nachbarschaft"
              subText={`Erfahren Sie mehr über die Menschen in ${this.props.location} und Umgebung.`}
              cosmaIcon="is24-icon-persons"
            />
            {this.renderResponsiveStats()}
            <div className="grid-item one-whole padding-top-l align-left">
              <span id="DeutschePostDirekt" className="font-xs font-lightgray">
                Quelle: © 2022 Deutsche Post Direkt GmbH
              </span>
            </div>
          </div>
          <div className={styles.widgetIllustration}>
            <div className="grid grid-flex">
              <div className="grid-item grid-align-center">
                <img
                  alt=""
                  src="https://www.static-immobilienscout24.de/statpic/sales-journey/it/atlas/05183d9c302fd5554603ff999a67c6bc_Illustration_Functional_Black_Devices.png"
                />
              </div>
            </div>
          </div>
        </div>
      </WidgetFrame>
    );
  }
}

DemographicInfoWidget.propTypes = {
  location: PropTypes.string.isRequired,
  demographicInfo: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  location: getLocationName(state),
  demographicInfo: getDemographicInfo(state),
});

export default connect(mapStateToProps)(DemographicInfoWidget);
